var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6673 7.00004C12.6673 10.1297 10.1303 12.6667 7.00065 12.6667C3.87104 12.6667 1.33398 10.1297 1.33398 7.00004C1.33398 3.87043 3.87104 1.33337 7.00065 1.33337C10.1303 1.33337 12.6673 3.87043 12.6673 7.00004ZM13.6673 7.00004C13.6673 10.6819 10.6825 13.6667 7.00065 13.6667C3.31875 13.6667 0.333984 10.6819 0.333984 7.00004C0.333984 3.31814 3.31875 0.333374 7.00065 0.333374C10.6825 0.333374 13.6673 3.31814 13.6673 7.00004ZM5.33398 3.00004H6.66732V11H5.33398V3.00004ZM10.6673 9.66671H9.33398V4.33337H10.6673V9.66671ZM3.33398 9.00004H4.66732V5.00004H3.33398V9.00004ZM8.66732 9.00004V5.66671H7.33398V9.00004H8.66732Z",
    fill: "#4D4E65"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/Audio.2554664ecdd2c94833fc886eb1156eb8.svg";
export { ForwardRef as ReactComponent };